import { Component, ReactNode, Suspense } from "react";
import { AppNonIdealState } from "../components/AppNonIdealState";
import { Outlet } from "react-router";
import { HeaderLoader } from "../components/HeaderLoading";

class ErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: unknown) {
    console.error("Error caught by boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <AppNonIdealState />;
    }
    return this.props.children;
  }
}

export function Content() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<HeaderLoader />}>
        <Outlet />
      </Suspense>
    </ErrorBoundary>
  );
}
